const API_SERVERS = {
  local: "https://kudosta.com/YbghWqrjlO/api",
  live: "https://kudosta.com/YbghWqrjlO/api",
};

const SITE_BASE_URLS = {
  local: "http://localhost:3000",
  live: "https://kudosta.com",
};

// Set this to "local" while developing locally,
// and change to "live" before saving/building for deployment.
let activeServer = "live";

const normalizeUrl = (value = "") => value.replace(/\/+$/g, "").trim();
const normalizePath = (value = "") => value.toString().replace(/^\/+/, "");

export const setApiServer = (serverName) => {
  if (!API_SERVERS[serverName]) {
    throw new Error(`Unknown API server: ${serverName}`);
  }
  activeServer = serverName;
};

export const getApiServer = () => activeServer;

export const getApiBaseUrl = () => normalizeUrl(API_SERVERS[activeServer]);

export const getApiUrl = (endpoint = "") => {
  const path = normalizePath(endpoint);
  return `${getApiBaseUrl()}/${path}`;
};

export const getSiteBaseUrl = () => normalizeUrl(SITE_BASE_URLS[activeServer]);

export const getAssetUrl = (path = "") => {
  const relativePath = normalizePath(path);
  return relativePath ? `${getSiteBaseUrl()}/${relativePath}` : getSiteBaseUrl();
};

export const getUploadsUrl = (folder = "", filename = "") => {
  const pathParts = ["uploads"];

  if (folder) pathParts.push(normalizePath(folder));
  if (filename) pathParts.push(normalizePath(filename));

  return getAssetUrl(pathParts.join("/"));
};

export const getImageUrl = (folder, filename) => {
  if (!filename) return null;
  return getUploadsUrl(folder, filename);
};

export async function fetchApi(endpoint, options = {}) {
  const response = await fetch(getApiUrl(endpoint), options);
  if (!response.ok) {
    const body = await response.text();
    throw new Error(`API request failed (${response.status}): ${body}`);
  }
  return response.json();
}

export default {
  servers: API_SERVERS,
  baseUrls: SITE_BASE_URLS,
  getApiServer,
  setApiServer,
  getApiBaseUrl,
  getApiUrl,
  getSiteBaseUrl,
  getAssetUrl,
  getUploadsUrl,
  getImageUrl,
  fetchApi,
};
